webpackJsonp([10],{

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint one-var: "off" */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(3),
		__webpack_require__(14),
		__webpack_require__(5),
		__webpack_require__(12)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, loader, pubsub, nanoajax) {
		'use strict';
	
		/**
		 * AjaxForm
		 * A plugin that add ajax-request to forms.
		 * @version 1.0.0
		 * @exports ajaxForm
		 */
		return function () {
			var ajaxForm = {
	
				/** Placeholder for base DOM element. */
				el: null,
	
				/** Placeholder for template (used if this plugin is used with json). */
				template: null,
	
				/** Target DOM id (the list). */
				targetId: null,
	
				/** Placeholder for target DOM element (the list). */
				targetEl: null,
	
				/** Placeholder for array of DOM elements that should be updated on render. */
				syncEls: null,
	
				/** Placeholder for pager DOM element. */
				pager: null,
	
				/** Boolean to indicate if there are any ajax-request in progress. */
				requestInProgress: false,
	
				/** 1 =DOESN'T WORK CORRECTLY RIGHT NOW.  back button navigates between searches. 0 = back button navigates to previous, referring page. */
				supportBackButton: 0,
	
				/** Selector for items. */
				itemSelector: 'article',
	
	
				/**
				 * Constructor function.
				 * @private
				 */
				_constructor: function () {
					return this;
				},
	
	
				/**
				 * The initialization function for this module.
				 * @param {Object} el - A DOM node.
				 * @public
				 */
				init: function (el) {
					this.el = el;
					this.targetId = el.getAttribute('aria-controls');
					this.targetEl = document.getElementById(this.targetId);
					this.pager = document.querySelector('[data-type="loadMore"]');
	
					if (this.targetEl === null) {
						return false;
					}
	
					if (el.getAttribute('data-itemselector') !== null) {
						this.itemSelector = el.getAttribute('data-itemselector');
					}
	
					if (el.getAttribute('data-sync') !== null) {
						this.syncEls = el.getAttribute('data-sync').split('|');
					}
	
					this._loadTemplates();
					this._initSubscriptions();
				},
	
	
				/**
				 * Function that loads content through ajax.
				 * @param {String} queryOverride - A query as a string to be used instead of the form values.
				 * @private
				 */
				_load: function (queryOverride) {
					var that = this,
						method = this.el.getAttribute('method') ? this.el.getAttribute('method') : 'GET',
						url = this.el.getAttribute('action'),
						ajaxUrl = this.el.getAttribute('data-ajaxurl'),
						loadingMessage = this.el.getAttribute('data-loading-message') || 'Laddar',
						query;
	
					if (this.requestInProgress === false) {
						this.requestInProgress = true;
						loader.loadingStart(this.targetEl, loadingMessage, 'large');
						query = queryOverride || utils.formToQuery(this.el);
	
						url = url.indexOf('?') === -1 ? url + '?' + query : url + '&' + query;
	
						if (ajaxUrl !== null && ajaxUrl !== undefined) {
							ajaxUrl = ajaxUrl.indexOf('?') === -1 ? ajaxUrl + '?' + query : ajaxUrl + '&' + query;
						}
	
						if (method.toLowerCase() === 'get') {
							this._pathchange(url);
						}
	
						// Fixes a bug in Chrome
						url = url.indexOf('?') === -1 ? url + '?_=' + utils.getTimestamp() : url + '&_=' + utils.getTimestamp();
	
						if (ajaxUrl) {
							ajaxUrl = ajaxUrl.indexOf('?') === -1 ? ajaxUrl + '?_=' + utils.getTimestamp() : ajaxUrl + '&_=' + utils.getTimestamp();
						}
	
						nanoajax.ajax({
							method: method,
							headers: {
								'X-Requested-With': 'XMLHttpRequest'
							},
							url: ajaxUrl || url
						},
						function (code, responseText, request) {
							if (code === 200) {
								var ct = request.getResponseHeader('content-type') || '';
	
								that.targetEl.innerHTML = '';
	
								if (ct.indexOf('html') > -1) {
									that._renderHtml(responseText);
								}
								else if (ct.indexOf('json') > -1) {
									that._renderJson(responseText);
								}
	
								if (that.el.getAttribute('data-singlepost')) {
									utils.forEachElement('[data-singlepost="' + that.el.getAttribute('data-singlepost') + '"]', function (form) {
										var submitBtn = form.querySelector('[type="submit"]');
										submitBtn.setAttribute('disabled', 'disabled');
										utils.addClass(submitBtn, 'is-disabled');
									});
									utils.forEachElement('[data-singlepost-disable="' + that.el.getAttribute('data-singlepost') + '"]', function (btn) {
										btn.setAttribute('disabled', 'disabled');
										utils.addClass(btn, 'is-disabled');
									});
								}
	
								that.requestInProgress = false;
							}
						});
					}
				},
	
	
				/**
				 * Function that renders new html-data.
				 * @param {String} data - New data as a string of html.
				 * @private
				 */
				_renderHtml: function (data) {
					var parser = new DOMParser(),
						doc = parser.parseFromString(data, 'text/html'),
						newPager, newItems;
	
					newPager = doc.querySelector('[data-type="loadMore"]');
					newItems = doc.querySelectorAll('#' + this.targetId + ' ' + this.itemSelector);
	
					for (var i = 0; i < newItems.length; i++) {
						this.targetEl.appendChild(newItems[i]);
	
						if (i === 0) {
							var firstLink = newItems[i].querySelector('a');
	
							if (firstLink !== null) {
								firstLink.focus();
							} else {
								newItems[i].focus();
							}
						}
					}
	
					//this.itemCount.push(newItems.length);
	
					if (this.pager !== null) {
						if (newPager === null) {
							if (this.pager.remove) {
								this.pager.remove();
							} else {
								this.pager.parentNode.removeChild(this.pager);
							}
						} else {
							this.pager.setAttribute('href', newPager.getAttribute('href'));
						}
					}
	
					pubsub.publish('/ajaxForm/list/updated');
				},
	
	
				/**
				 * Function that renders new json-data.
				 * @param {String} data - New data as a string of json.
				 * @private
				 */
				_renderJson: function (data) {
					var html = '',
						oldItems = null,
						newItems = null,
						spellSuggestionHolder = document.getElementById('spellSuggestion'),
						firstLink;
	
					try {
						data = JSON.parse(data);
						html = this.template(data);
					} catch (e) {}
	
					if (this.pager !== null) {
						if (data.pagerUrl === undefined || data.pagerUrl === null || data.pagerUrl === '') {
							utils.addClass(this.pager, 'is-hidden');
						} else {
							utils.removeClass(this.pager, 'is-hidden');
							this.pager.setAttribute('href', data.pagerUrl);
						}
					}
	
					oldItems = this.targetEl.querySelectorAll(this.itemSelector);
					this.targetEl.insertAdjacentHTML('BeforeEnd', html);
					newItems = this.targetEl.querySelectorAll(this.itemSelector);
	
					if (this.syncEls !== null) {
						this._syncElementsJson(data);
					}
	
					// Some special for the map
					if (data.plants_for_map !== undefined) {
						pubsub.publish('/map/update', data.plants_for_map);
					}
	
					// Some special for the search
					if (data.suggestions && data.suggestions.length > 0) {
						var spellSuggestionLinkHolder = document.getElementById('spellSuggestionLink'),
							searchPageUrl = '',
							spellSuggestionContent = '';
	
						if (spellSuggestionHolder !== null && spellSuggestionLinkHolder !== null) {
							searchPageUrl = spellSuggestionHolder.getAttribute('data-searchpage-url');
							searchPageUrl += searchPageUrl.indexOf('?') !== -1 ? '&q=' : '?q=';
	
							for (var i = 0; i < data.suggestions.length; i++) {
								spellSuggestionContent += '<a href="' + searchPageUrl + data.suggestions[i] + '">' + data.suggestions[i] + '</a>';
								if (i !== data.suggestions.length - 1) {
									spellSuggestionContent += ', ';
								}
							}
							spellSuggestionLinkHolder.innerHTML = spellSuggestionContent;
							utils.removeClass(spellSuggestionHolder, 'is-hidden');
						}
					} else {
						if (spellSuggestionHolder !== null) {
							utils.addClass(spellSuggestionHolder, 'is-hidden');
						}
					}
	
					if (newItems[oldItems.length] !== null && newItems[oldItems.length] !== undefined) {
						firstLink = newItems[oldItems.length].querySelector('a');
						if (firstLink !== null) {
							firstLink.focus();
						} else {
							newItems[oldItems.length].focus();
						}
					}
	
					pubsub.publish('/ajaxForm/list/updated');
				},
	
	
				/**
				 * Function that sync other elements after update (with JSON-data).
				 * @param {String} data - New data as a string of json.
				 * @private
				 */
				_syncElementsJson: function (data) {
					for (var i = 0; i < this.syncEls.length; i++) {
						var el = document.getElementById(this.syncEls[i]),
							syncWith = el.getAttribute('data-sync-with'),
							template = el.getAttribute('data-sync-template');
	
						if (template !== null) {
							if (syncWith !== null) {
								el.innerHTML = '';
								el.insertAdjacentHTML('BeforeEnd', el.template(utils.objectByString(data, syncWith)));
							} else {
								el.innerHTML = '';
								el.insertAdjacentHTML('BeforeEnd', el.template(data));
							}
						}
	
						if (syncWith !== null) {
							el.innerHTML = '';
							el.insertAdjacentHTML('BeforeEnd', utils.objectByString(data, syncWith));
						}
					}
					pubsub.publish('/ajaxForm/sync/updated');
				},
	
	
				/**
				 * Function that loads all template-files needed by the ajaxForm.
				 * @private
				 */
				_loadTemplates: function () {
					var that = this,
						templates = [],
						loadedTemplates = 0;
	
					// Get "base" template for the list
					if (this.el.getAttribute('data-template') !== undefined) {
						templates.push({ el: this, tpl: this.el.getAttribute('data-template') });
					}
	
					// See if we have any other elements that wants to be synced with a template.
					if (this.syncEls !== null) {
						for (var i = 0; i < this.syncEls.length; i++) {
							var el = document.getElementById(this.syncEls[i]),
								template = el.getAttribute('data-sync-template');
	
							if (template !== null) {
								templates.push({ el: el, tpl: template });
							}
						}
					}
	
					// Initiate if we have no templates, otherwise we initiate after all templates has been loaded.
					if (templates.length === 0) {
						this._initEvents();
					} else {
						for (var j = 0; j < templates.length; j++) {
							var obj = templates[j];
	
							that._loadTemplate(obj.el, obj.tpl, _loadCallback);
						}
					}
	
					function _loadCallback () {
						loadedTemplates += 1;
	
						if (loadedTemplates === templates.length) {
							that._initEvents();
						}
					}
				},
	
	
				/**
				 * Function that loads a single template-file for an element.
				 * @param {Object} el - A DOM node which use the template.
				 * @param {String} template - The template name.
				 * @param {Object} callback - An callback function after the template has been loaded.
				 * @private
				 */
				_loadTemplate: function (el, template, callback) {
					__webpack_require__.e/* require */(9/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(25)("./" + template + '.hbs')]; (function (tpl) {
						el.template = tpl;
						callback();
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				},
	
	
				/**
				 * Function that updates the url.
				 * @private
				 */
				_pathchange: function (url) {
					if (utils.hasHistorySupport()) {
						if (this.supportBackButton === 1) {
							window.history.pushState(null, null, url);
						} else {
							window.history.replaceState(null, null, url);
						}
					}
				},
	
	
				/**
				 * Initiates events.
				 * @private
				 */
				_initEvents: function () {
					var that = this;
	
					utils.addEventListener(this.el, 'submit', function (event) {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
						that._load();
					});
				},
	
	
				/**
				 * Initiates subscriptions.
				 * @private
				 */
				_initSubscriptions: function () {
					var that = this;
	
					pubsub.subscribe('/ajaxForm/load', function (data) {
						that._load(data.query);
					});
				}
			};
	
			return ajaxForm._constructor();
		};
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })

});


// WEBPACK FOOTER //
// partial.10.js